import React, { ReactElement } from 'react';
import Badges from '@/UI/Badges';
import Completed from '@/UI/Completed';
import CentredLayout from './CentredLayout';
import { Divider } from 'antd';

export default function Thanks(): ReactElement {
    return (
        <CentredLayout pageName='thanks'>
            <Completed className='completed-icon' />
            <h3 className='headline'>Your quote is submitted.</h3>
            <p className='sub-headline'>We&apos;re here to make this process as smooth and quick as possible for you.</p>
            <div className='next-steps'>
                <h5 className='headline'>We&apos;re excited to help you on your financial journey. Here&apos;s what happens next:</h5>
                <ul className='details'>
                    <li><strong>Assessment:</strong> Expect to receive your quote outcome via email within 4 business hours. If you submitted your quote request before midday AEST, our credit team will respond by the end of the day.</li>
                    <li><strong>Finalise application:</strong> Once you receive your quote, we&apos;ll need a bit more information to finalise your application if you decide to go ahead. Keep an eye out for an email confirming your quote details.</li>
                </ul>
            </div>
            <p className='closing'> Thank you for considering Funding.</p>
            <Divider />
            <p className='question'>Need some help?</p>
            <p className='answer'>If you get stuck, we&apos;re here to help answer your questions and guide you through the application.</p>
            <p className='contact'>Call us: <a className='phone' href='tel:1300443319'>1300 44 33 19</a></p>
            <Badges />
        </CentredLayout>
    );
}

